/*
 * @fileOverView Search Employer component definition
 */

import Vue from 'vue';
import { mapState } from 'vuex';
/**
 * [Employer Results Vue]
 * @type {class}
 */
Vue.component('employer-match-results-vue', {
  data: function() {
    return {
      detailsLoaded: false
    }
  },

  computed: {
    ...mapState('employers', ['list', 'hasSearched'])
  },

  methods: {
    /**
     * Upon click of View More, this method will retrieve the details of the employer.
     *
     * After retriving the details, will prepare and open the modal providing more information.
     * @param {Integer} index
     */
    handleItemSelected(index) {
      this.detailsLoaded = false;

      const employer = this.list[index];
      let id = employer.company_id;
      if (employer.subsidiary === 'true') {
        id = employer.subsidiary_id;
      }

      this.$store.dispatch('employers/getDetails', id).then(() => {
        this.$nextTick(() => {
          this.detailsLoaded = true;
        })
      });
    }
  }
});
